import { Modal } from "antd";
import { Assets } from "utils/Assets";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomButton from "./CustomButton";

const PaymentSuccessModal = ({ paymentSuccessModal, setPaymentSuccessModal }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const userDetail = useSelector(state => state?.common?.user_data);
    const unitAmount = userDetail?.subscription_detail?.items?.data?.[0]?.price?.unit_amount / 100 || 0; // Convert cents to dollars
    const quantity = userDetail?.subscription_detail?.items?.data?.[0]?.quantity || 1; // Number of units purchased (e.g., teams)
    const totalAmount = unitAmount * quantity;

    return (
        <>
            <Modal title={<img src={Assets.darkLogo} width={180} alt="" />} open={paymentSuccessModal} footer='' onCancel={() => { location.pathname === '/settings' ? navigate('/my-plan', { replace: true }) : navigate('/welcome', { replace: true }); setPaymentSuccessModal(false) }} closeIcon={<img src={Assets.closeIcon} alt="" />}>
                <div className="text-center">
                    <img src={Assets.successGif} alt="" width={200} />
                    {userDetail?.upgradeTime || userDetail?.is_subscription_purchased ? (
                        <>
                            <h1 className="big_font fw-bold">Subscription Upgrade Successfully</h1>
                            <h1 className="medium_font">Next billing amount to be deducted is -- ${totalAmount.toFixed(2)}</h1>
                        </>
                    ) : (
                        <h1 className="big_font">Subscription Purchased Successfully</h1>
                    )}
                    <div className="btn_border border-black w-50 mx-auto mt-4">
                        <CustomButton onClick={() => { location.pathname === '/settings' ? navigate('/my-plan', { replace: true }) : navigate('/welcome', { replace: true }); setPaymentSuccessModal(false) }} className="text-black" style={{ background: `var(--green)`, width: '100%' }}>Next</CustomButton>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default PaymentSuccessModal;
